import React, { useState } from "react";
import BackToSchoolImageUpdated from "assets/images/TUT---Back-To-SchoolSocial-Media-Updated.png";
import ReceiptImage from "../assets/images/TUT--ReceiptSocialMedia.png";
import WeAuditThatUpdated from "../assets/images/TUT---Back-To-SchoolWeAuditThat-Updated.png";
import UtahTeachers from "../assets/images/TUT--Education-DashboardCompensation_SM.png";
import WheresTheMoney from "../assets/images/TUT---What-Tina-FoundSoical-Media.png";
import HowMany from "../assets/images/TUT---License-PlatesHowManyPlates.png";
import StreamingVideo from "./StreamingVideo";
import { Card, Button, Collapse } from "react-bootstrap";


const FeaturedDataStories = () => {
  const [error, setError] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open6, setOpen6] = useState(false);

  const handleError = () => {
    setError(true);
  };

  return (
    <section id="data-stories" className="py-5 featured-data-stories" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold mb-3">Featured Data Stories</h2>
          <p className="lead text-muted">Discover insights from Utah's government data</p>
        </div>

        {/* First Row */}
        <div className="row g-5 mb-5">
          {/* Card 1 */}
          <div className="col-lg-4 col-md-6">
            <div
              className="card-wrapper"
            >
              <Card className="h-100 shadow-sm featured-data-card">
                <Card.Img variant="top" src={BackToSchoolImageUpdated} className="card-img-square card-img-rectangle" alt="Back to School" />
                <Card.Body
                  className="d-flex flex-column"
                  style={{ minHeight: "300px" }}
                >
                  <Card.Title as="h3" style={{ fontWeight: 500 }}>How Does Your School Measure Up?</Card.Title>
                  <Card.Text>Explore education spending trends and back-to-school budget allocations across Utah's school districts.</Card.Text>

                  <Collapse in={open1}>
                    <div className="border-top" id="collapse-text-1" style={{ paddingTop: "1.5rem" }}>
                      <p>Utah’s first school term is complete, and Transparent Utah makes it easier than ever to see how your tax dollars are making a difference. With just a few clicks, you can explore spending data for every school in the state — from classroom investments to extracurricular funding — and see how that spending connects to actual performance outcomes.</p>

                      <p>This isn’t just about numbers on a page. It’s about understanding how funding shapes student success. Are higher-spending schools seeing better results? Which schools are doing more with less? Transparent Utah gives you the tools to find out.</p>

                      <p>Whether you’re a parent, teacher, or taxpayer, you can use the site to see how your local school compares to others across the state. Because when it comes to education, transparency helps everyone make informed decisions — and helps ensure that every dollar spent supports Utah’s students. </p>

                      <p>See the <strong><a href="https://transparent.utah.gov/spending-map/" target="_blank"
                        rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Public Education (K-12) Spending Dashboard</a></strong> for more details.
                      </p>
                    </div>
                  </Collapse>
                  <Button
                    variant="outline-secondary"
                    className="mt-auto w-100"
                    onClick={() => setOpen1(current => !current)}
                    aria-controls="collapse-text-1" aria-expanded={open1}>
                    {open1 ? "Show Less" : "Learn More"}
                  </Button>
                </Card.Body>
              </Card>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-lg-4 col-md-6">
            <div
              className="card-wrapper"
            >
              <Card className="h-100 shadow-sm featured-data-card">
                <Card.Img variant="top" src={ReceiptImage} className="card-img-square card-img-rectangle" alt="Bank of YOUtah" />
                <Card.Body
                  className="d-flex flex-column"
                  style={{ minHeight: "300px" }}
                >
                  <Card.Title as="h3" style={{ fontWeight: 500 }}>Bank of YOUtah</Card.Title>
                  <Card.Text>When public funds meant to create jobs are spent on cruises and luxury perks, Utahns deserve to know.</Card.Text>

                  <Collapse in={open2}>
                    <div className="border-top" id="collapse-text-2" style={{ paddingTop: "1.5rem" }}>
                      <p>A recent state audit uncovered how $2.8 million of Utah taxpayer money—intended to boost manufacturing jobs—was instead spent on personal perks and luxury items. Meals, Amazon orders, salon visits, exercise equipment, Vegas getaways, and even luaus were all charged to funds meant for economic growth.</p>

                      <p>The money flowed through the Impact Utah program, which was supposed to help small manufacturers expand and hire more workers. But because of the lack of oversight and accountability, the funds went toward inflated salaries and personal spending that had little to do with job creation.</p>

                      <p>Transparent Utah makes it easy to see the details behind this misuse of taxpayer dollars. Explore the full Impact Utah audit to see who was responsible, how the money was used, and what steps are being taken to hold those involved accountable.</p>

                      <p>Because transparency isn’t just about numbers; it’s about protecting Utah’s taxpayers and ensuring every dollar goes where it should.</p>

                      <p>See the <strong><a href="https://reporting.auditor.utah.gov/servlet/servlet.FileDownload?file=015Do0000017l7iIAA" target="_blank"
                        rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Impact Utah</a></strong> audit report for more details.</p>
                    </div>
                  </Collapse>
                  <Button
                    variant="outline-secondary"
                    className="mt-auto w-100"
                    onClick={() => setOpen2(current => !current)}
                    aria-controls="collapse-text-2" aria-expanded={open2}>
                    {open2 ? "Show Less" : "Learn More"}
                  </Button>
                </Card.Body>
              </Card>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-lg-4 col-md-6">
            <div
              className="card-wrapper"
            >
              <Card className="h-100 shadow-sm featured-data-card">
                <Card.Img variant="top" src={HowMany} className="card-img-square card-img-rectangle" alt="License Plate Revenue" />
                <Card.Body
                  className="d-flex flex-column"
                  style={{ minHeight: "300px" }}
                >
                  <Card.Title as="h3" style={{ fontWeight: 500 }}>How Much Money Do Custom Plates Generate?</Card.Title>
                  <Card.Text>From wildlife to universities — see which Utah license plates are most popular and how they fund state programs.</Card.Text>

                  <Collapse in={open3}>
                    <div className="border-top" id="collapse-text-3" style={{ paddingTop: "1.5rem" }}>
                      <p>Did you know that your license plate can do more than personalize your car? In Utah, custom license plates not only show support for a cause or organization — they also help fund it. Each time a driver purchases a specialty plate, part of the fee goes directly to the sponsoring group or program.</p>

                      <p>On Transparent Utah, you can explore how many specialty plates have been issued and how much revenue each one has generated. See which plates are the most popular across the state and how much financial support they’ve provided to their causes.</p>

                      <p>Whether it’s supporting wildlife conservation, education, veterans, or local universities, every plate tells a story about what Utahns care about most.</p>

                      <p>Use the data to see how your favorite program stacks up — and discover how something as simple as a license plate helps drive real impact across the state.</p>

                      <p>See the <strong><a href="https://transparent.utah.gov/specialty-license-report/" target="_blank"
                        rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Specialty License Plates Dashboard</a></strong> for more details.
                      </p>
                    </div>
                  </Collapse>
                  <Button
                    variant="outline-secondary"
                    className="mt-auto w-100"
                    onClick={() => setOpen3(current => !current)}
                    aria-controls="collapse-text-3" aria-expanded={open3}>
                    {open3 ? "Show Less" : "Learn More"}
                  </Button>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>

        {/* Second Row */}
        <div className="row g-5 mb-5">
          {/* Card 4 */}
          <div className="col-lg-4 col-md-6">
            <div
              className="card-wrapper"
            >
              <Card className="h-100 shadow-sm featured-data-card">
                <Card.Img variant="top" src={UtahTeachers} className="card-img-square card-img-rectangle" alt="Where Do Teachers Get the Best Wages and Benefits?" />
                <Card.Body
                  className="d-flex flex-column"
                  style={{ minHeight: "300px" }}
                >
                  <Card.Title as="h3" style={{ fontWeight: 500 }}>Where Do Teachers Get the Best Wages and Benefits?</Card.Title>
                  <Card.Text>See which Utah schools and districts offer the most competitive pay and benefits for educators.</Card.Text>

                  <Collapse in={open4}>
                    <div className="border-top" id="collapse-text-4" style={{ paddingTop: "1.5rem" }}>
                      <p>Teachers are the foundation of every successful community, and Transparent Utah helps shine a light on how they’re supported across the state. With our educator pay and benefits data, you can see more than just salary numbers — you can explore the full compensation picture.</p>

                      <p>Compare districts to learn which offer the strongest benefits packages, including paid time off, flexible spending accounts (FSAs), 401(k) plans, health insurance, and other key supports. Whether you’re an educator looking to make a career move or a community member advocating for fair compensation, Transparent Utah provides the tools to make informed decisions.</p>

                      <p>As a teacher, you are a vital community asset — shaping the next generation while providing for your own family. Transparent Utah gives you the clarity to see where your skills, passion, and expertise are valued most.</p>

                      <p>See the <strong><a href="https://transparent.utah.gov/teacher-pay/" target="_blank"
                        rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Teacher Pay Dashboard</a></strong> for more details.
                      </p>
                    </div>
                  </Collapse>
                  <Button
                    variant="outline-secondary"
                    className="mt-auto w-100"
                    onClick={() => setOpen4(current => !current)}
                    aria-controls="collapse-text-4" aria-expanded={open4}>
                    {open4 ? "Show Less" : "Learn More"}
                  </Button>
                </Card.Body>
              </Card>
            </div>
          </div>

          {/* Card 5 */}
          <div className="col-lg-4 col-md-6">
            <div
              className="card-wrapper"
            >
              <Card className="h-100 shadow-sm featured-data-card">
                <Card.Img variant="top" src={WeAuditThatUpdated} className="card-img-square card-img-rectangle" alt="We Audit That!" />
                <Card.Body
                  className="d-flex flex-column"
                  style={{ minHeight: "300px" }}
                >
                  <Card.Title as="h3" style={{ fontWeight: 500 }}>So Much More Than Financial Data</Card.Title>
                  <Card.Text>See what really drives success in Utah’s schools — from after-school programs to technology and student support.</Card.Text>

                  <Collapse in={open5}>
                    <div className="border-top" id="collapse-text-5" style={{ paddingTop: "1.5rem" }}>
                      <p>Schools are about more than just test scores and budgets — they’re about the experiences, opportunities, and support that help every student thrive. On Transparent Utah, you can explore a new dashboard that looks beyond spending to show how schools perform across multiple areas that matter.</p>

                      <p>See how your school invests in after-school programs, special education, classroom technology, and even lunch services. Explore how districts manage their funds and stay in compliance. You can compare schools side-by-side and discover which ones are getting the best results from their resources.</p>

                      <p>This is transparency designed to help you understand the full picture — not just the dollars and cents. Whether you’re a parent, teacher, or community member, Transparent Utah helps you see how your local schools are using taxpayer dollars to support students every day.</p>

                      <p>See the <strong><a href="https://transparent.utah.gov/spending-map/" target="_blank"
                        rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Public Education (K-12) Spending Dashboard</a></strong> for more details.</p>
                    </div>
                  </Collapse>
                  <Button
                    variant="outline-secondary"
                    className="mt-auto w-100"
                    onClick={() => setOpen5(current => !current)}
                    aria-controls="collapse-text-5"
                    aria-expanded={open5}
                  >
                    {open5 ? "Show Less" : "Learn More"}
                  </Button>
                </Card.Body>
              </Card>
            </div>
          </div>

          {/* Card 6 */}
          <div className="col-lg-4 col-md-6">
            <div
              className="card-wrapper"
            >
              <Card className="h-100 shadow-sm featured-data-card" as="article">
                <Card.Img variant="top" src={WheresTheMoney} className="card-img-square card-img-rectangle" alt="Where does the Money Go" />
                <Card.Body
                  className="d-flex flex-column"
                  style={{ minHeight: "300px" }}
                >
                  <Card.Title as="h3" style={{ fontWeight: 500 }}>Where Does the Most Money Go?</Card.Title>
                  <Card.Text>See how education funding is distributed across Utah — and how your school measures up.</Card.Text>
                  <Collapse in={open6}>
                    <div className="border-top" id="collapse-text-6" style={{ paddingTop: "1.5rem" }}>
                      <p>Every community invests in education, but not all schools receive the same amount of funding. On Transparent Utah, you can explore where education dollars go — from state allocations to local school budgets — and see how those resources are used to support students.</p>

                      <p>Discover which counties, cities, and districts receive the most funding and how your school compares. You’ll see patterns that can spark important conversations about equity, priorities, and outcomes in your community.</p>

                      <p>Parents, PTSA members, and Community Councils can use this information to make meetings more productive and data-driven. Whether you’re discussing classroom resources, technology needs, or after-school programs, Transparent Utah provides the facts you need to back your ideas and collaborate with confidence.</p>

                      <p>Because when everyone has access to the same information, communities can work together to make sure every dollar helps Utah’s students thrive.</p>

                      <p>See <strong><a href="https://transparent.utah.gov/lea-revenue/" target="_blank"
                        rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Jamie Renda's Utah Education Funding Dashboard</a></strong> for more details.</p>
                    </div>
                  </Collapse>
                  <Button
                    variant="outline-secondary"
                    className="mt-auto w-100"
                    onClick={() => setOpen6(current => !current)}
                    aria-controls="collapse-text-6" aria-expanded={open6}>
                    {open6 ? "Show Less" : "Learn More"}
                  </Button>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>

        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold mb-3">Reintroducing Transparent Utah</h2>
        </div>

        <div className="video-container" style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
          {error ? (
            <div className="bg-danger d-flex align-items-center justify-content-center" style={{ height: "100%" }}>
              <div className="text-center text-black">
                <p className="lead">Error: The video failed to load.</p>
              </div>
            </div>
          ) : (
            // <StreamingVideo videoFile="TUT - Introduction LongForm.mp4" onError={handleError} /> // Original version without VTT caption
            <StreamingVideo videoFile="TUT - Introduction LongForm.mp4" vttFile="transparent-utah-homepage-video-transcript.vtt" onError={handleError} />
          )}
        </div>
      </div>
    </section>
  );
};

export default FeaturedDataStories;